export class TimeDefinitionService {
  constructor() {
    this.timeCodeMap = { day: '1', sunset: '2', night: '3' };
    this.timeSlotMap = { '1': 'day', '2': 'sunset', '3': 'night' };
    this.numericTimeMap = { '0.1': 'day', '1': 'day', '0.2': 'sunset', '2': 'sunset', '0.3': 'night', '3': 'night' };
    this.defaultHours = { day: 12, sunset: 18, night: 21 };
    this.timeAliases = { morning: 'day', afternoon: 'day', evening: 'sunset', sunrise: 'sunset', hour: 'night' };
  }

  hourToTimeOfDay(hour) {
    const h = parseInt(hour, 10);
    if (h >= 0 && h <= 5) return 'night';
    if (h >= 6 && h <= 7) return 'sunset';
    if (h >= 8 && h <= 17) return 'day';
    if (h >= 18 && h <= 19) return 'sunset';
    if (h >= 20 && h <= 23) return 'night';
    return 'night';
  }

  getImageSuffix(timeOfDay) {
    return this.timeCodeMap[timeOfDay] || 3;
  }

  getTimeOfDayFromSuffix(suffix) {
    return this.timeSlotMap[suffix] || 'night';
  }

  getTimeOfDayFromNumericSlot(slot) {
    return this.numericTimeMap[slot] || 'night';
  }

  getDefaultHour(timeOfDay) {
    return this.defaultHours[timeOfDay] || 12;
  }

  resolveTimeAlias(alias) {
    return this.timeAliases[alias] || alias;
  }

  getTimeOfDayLabel(timeOfDay) {
    const labels = { day: 'Day', sunset: 'Sunset', night: 'Evening', '0.1': 'Day', '0.2': 'Sunset', '0.3': 'Evening', '1': 'Day', '2': 'Sunset', '3': 'Evening' };
    return labels[timeOfDay] || 'Evening';
  }

  formatTimeOfDay(timeSlot, currentLocation = '') {
    const nightVenues = ['midnight lounge', 'rooftop bar', 'night club', 'jazz lounge', 'wine bar'];
    const isNightVenue = nightVenues.some(venue => currentLocation?.toLowerCase().includes(venue));
    const timeOfDay = this.getTimeOfDayFromNumericSlot(timeSlot) || timeSlot;
    const timeMap = {
      day: isNightVenue ? '02:00' : '12:00',
      sunset: isNightVenue ? '22:00' : '18:00',
      night: isNightVenue ? '02:00' : '21:00'
    };
    return timeMap[timeOfDay] || (isNightVenue ? '02:00' : '12:00');
  }

  isTimeInPeriod(hour, targetPeriod) {
    return this.hourToTimeOfDay(hour) === targetPeriod;
  }

  getValidTimePeriods() {
    return ['day', 'sunset', 'night'];
  }

  getValidTimeAliases() {
    return Object.keys(this.timeAliases);
  }
}

let instance = null;
export const getTimeDefinitionService = () => {
  if (!instance) instance = new TimeDefinitionService();
  return instance;
};

export default TimeDefinitionService;
